<template>
  <div quick-link>
    <div inner>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickLink',
};
</script>

<style lang="less">
@import "~@/less/proj";

[quick-link] {
  [inner] { .ib-list; }
}
@media (min-width: @screen-md-min) {
  [quick-link] {  }
}
@media (min-width: @screen-lg-min) {
  [quick-link] { .abs; .rb; .m; .w(50%);
    // [quick-link-item] + [quick-link-item]:before { .cnt; .abs; .lt(-1,0); .wh(1,100%); background: #e0e0e0; opacity: 0.4; }
  }
}
</style>
